import styled from 'styled-components';
import Card from 'components/Card';

// Container Components
export const ReviewContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const SummaryHeader = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.01) 100%)'
      : `linear-gradient(135deg, ${
          props.theme?.colors?.background?.primary || '#F8FAFC'
        } 0%, ${props.theme?.colors?.gray?.[100] || '#F1F5F9'} 100%)`};
  margin-bottom: 32px;
`;

// Customer Components
export const SummaryCustomer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CustomerAvatar = styled.div`
  width: 56px;
  height: 56px;
  background: ${(props) =>
    `linear-gradient(135deg, ${
      props.theme?.colors?.primary || '#fa4616'
    } 0%, #e03e0c 100%)`};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme?.colors?.white || 'white'};
  font-size: 20px;
  font-weight: 600;
`;

export const CustomerInfo = styled.div``;

export const CustomerName = styled.h3`
  font-size: 18px;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.primary || '#ffffff'
      : props.theme?.colors?.blueBlack || '#000033'};
  margin-bottom: 4px;
  margin-top: 0;
`;

export const CustomerContact = styled.p`
  font-size: 14px;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.secondary || '#94A3B8'
      : props.theme?.colors?.textGray?.secondary || '#64748B'};
  margin: 0;
`;

// Amount Components
export const SummaryAmount = styled.div`
  text-align: right;
`;

export const AmountLabel = styled.div`
  font-size: 13px;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.secondary || '#94A3B8'
      : props.theme?.colors?.textGray?.secondary || '#64748B'};
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

export const AmountValue = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: ${(props) => props.theme?.colors?.success || '#22C55E'};
`;

// Layout Components
export const TwoColumnLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

// Section Components
// SummarySection is now just Card - use Card directly
export const SummarySection = Card;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.primary || '#ffffff'
      : props.theme?.colors?.blueBlack || '#000033'};
`;

export const SectionIcon = styled.div`
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  display: flex;
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
    fill: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  }
`;

// List Components
export const SummaryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
`;

export const ItemLabel = styled.span`
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.secondary || '#94A3B8'
      : props.theme?.colors?.textGray?.secondary || '#64748B'};
`;

export const ItemValue = styled.span`
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.primary || '#ffffff'
      : props.theme?.colors?.blueBlack || '#000033'};
  font-weight: 500;
`;

// Transaction-specific styled components (used only in TransactionCredit)
export const ProcessingFeesItem = styled(SummaryItem)`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.08)'
        : 'rgba(0,0,0,0.08)'};
`;

export const TicketList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
`;

export const TicketItem = styled.div`
  padding: 8px 12px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.08)'
      : 'rgba(0,0,0,0.03)'};
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
`;

export const TicketInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SerialNumber = styled.span`
  background: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.disabled || '#475569'
      : props.theme?.colors?.gray?.[600] || '#475569'};
  color: ${(props) => props.theme?.colors?.white || 'white'};
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const TicketName = styled.span`
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.dark || '#CBD5E1'
      : props.theme?.colors?.textGray?.dark || '#334155'};
`;

export const TicketPrice = styled.span`
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.primary || '#ffffff'
      : props.theme?.colors?.blueBlack || '#000033'};
  font-weight: 500;
`;

export const TransactionDetails = styled.div`
  padding: 12px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(59,130,246,0.1)'
      : 'rgba(59,130,246,0.05)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(59,130,246,0.2)'
        : 'rgba(59,130,246,0.1)'};
  border-radius: 6px;
  margin-bottom: 16px;
`;

export const TransactionInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const TransactionLabel = styled.span`
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.secondary || '#94A3B8'
      : props.theme?.colors?.textGray?.secondary || '#64748B'};
  font-size: 14px;
`;

export const TransactionValue = styled.span`
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.primary || '#ffffff'
      : props.theme?.colors?.blueBlack || '#000033'};
  font-weight: 500;
  font-size: 14px;
`;

// Utility functions
export const getInitials = (name) => {
  if (!name) return '??';
  const parts = name.split(' ');
  if (parts.length >= 2) {
    return parts[0][0] + parts[parts.length - 1][0];
  }
  return name.substring(0, 2).toUpperCase();
};

export const formatAmount = (amount) => {
  const num = parseFloat(amount);
  if (isNaN(num)) return '$0.00';
  return `$${num.toFixed(2)}`;
};
